import { LogLevel, Modal, ModalType, showBanner } from '@sprint/sprint-react-components';
import React, { FunctionComponent, useContext } from 'react';
import { RepositoryFactoryContext } from '../../index';
import { ClientGroupsRequest } from '../../Api/ClientGroupsRequest';
import { ClientGroupType } from '../../Models/Enums';

interface Props {
    selectedRowsForDeletion: number[];
    dataGridEntitySingular: string;
    dataGridEntityPlural: string;
    modalShown: boolean;
    reloadDataGrid: () => void;
    closeModal: () => void;
    clientGroupType: ClientGroupType;
    mainEntityPlural: string;
    clientGroupEntity: string;
}

const ClientGroupsDeleteModal: FunctionComponent<Props> = (props: Props) => {
    const genericGroupsRepository = useContext(RepositoryFactoryContext).getApiRepository(
        new ClientGroupsRequest(props.clientGroupType),
    );

    const deleteRows = async (): Promise<boolean> => {
        return genericGroupsRepository
            .delete(props.selectedRowsForDeletion)
            .then((success: any) => {
                showBanner({
                    message: success.data.message,
                    level: LogLevel.SUCCESS,
                });
                props.reloadDataGrid();
                return true;
            })
            .catch((err: any) => {
                showBanner({
                    message: err?.message ?? err,
                    level: LogLevel.ERROR,
                });
                return false;
            });
    };

    return (
        <Modal
            isOpen={props.modalShown}
            type={ModalType.DELETE}
            title={
                props.selectedRowsForDeletion.length > 1
                    ? `Delete These ${props.dataGridEntityPlural ?? 'Rows'}`
                    : `Delete This ${props.dataGridEntitySingular ?? 'Row'}`
            }
            close={props.closeModal}
            onSubmit={deleteRows}
        >
            <>
                Are you sure you want to delete
                {props.selectedRowsForDeletion.length > 1
                    ? ` these ${props.selectedRowsForDeletion.length} ${(
                          props.dataGridEntityPlural ?? 'rows'
                      ).toLowerCase()}?`
                    : ` this ${(props.dataGridEntitySingular ?? 'row').toLowerCase()}?`}
                <>
                    <br />
                    <br />
                    {`All ${props.mainEntityPlural} will be removed from the ${props.clientGroupEntity} and the ${props.clientGroupEntity} will be deleted.`}
                </>
            </>
        </Modal>
    );
};

export default ClientGroupsDeleteModal;
